function ImportCosts({
  ii,
  pis,
  cofins,
  ipi,
  icms,
  afrmmTax,
  freightCollectTax,
  otherShippingTax,
  customsClearenceTax,
  storageTax,
  otherExpensesTax,
  productQuantityInContainer,
  portFreightPrice,
  setPortFreightPrice,
  targetPrice,
  dollarPrice,
  landFreightPrice,
  setLandFreightPrice,
  chinaPrice,
}) {
  const portFreightPerUnitValue = (
    portFreightPrice / productQuantityInContainer
  ).toFixed(2);
  const landFreightPerUnitValue = (
    landFreightPrice / productQuantityInContainer
  ).toFixed(2);

  const chinaPriceToBrl = (
    parseFloat(chinaPrice) * parseFloat(dollarPrice)
  ).toFixed(2);

  let totalTaxesCost = 0;

  console.log("other shipping tax: ", otherExpensesTax);

  return (
    <div className="flex flex-col gap-4 p-4 bg-gray-50 rounded-lg shadow-md">
      <div className="flex items-center gap-4">
        <label className="w-40 text-gray-700 font-semibold">
          Quantidade de Produto no Contêiner
        </label>
        <div className="flex gap-2 w-full">
          <input
            className="w-full p-2 border text-center border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
            disabled
            value={productQuantityInContainer}
          />
        </div>
      </div>
      <div className="flex items-center gap-4">
        <label className="w-40 text-gray-700 font-semibold">
          Frete Marítimo $
        </label>
        <div className="flex gap-2 w-full">
          <input
            className="w-full p-2 border text-center border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
            value={portFreightPrice}
            onChange={(e) => setPortFreightPrice(e.target.value)}
          />
          <input
            className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
            disabled
            value={
              "R$ " +
              (typeof portFreightPerUnitValue === "string" &&
              portFreightPerUnitValue !== "NaN"
                ? portFreightPerUnitValue
                : 0)
            }
          />
        </div>
      </div>
      {[
        {
          label: "II",
          value: ii,
          totalValue: (
            (parseFloat(targetPrice) + parseFloat(portFreightPerUnitValue)) *
            ii *
            dollarPrice
          ).toFixed(2),
        },
        {
          label: "PIS",
          value: pis,
          totalValue: (
            (parseFloat(targetPrice) + parseFloat(portFreightPerUnitValue)) *
            pis *
            dollarPrice
          ).toFixed(2),
        },
        {
          label: "COFINS",
          value: cofins,
          totalValue: (
            (parseFloat(targetPrice) + parseFloat(portFreightPerUnitValue)) *
            cofins *
            dollarPrice
          ).toFixed(2),
        },
        {
          label: "IPI",
          value: ipi,
          totalValue: (
            (parseFloat(targetPrice) + parseFloat(portFreightPerUnitValue)) *
            ipi *
            dollarPrice
          ).toFixed(2),
        },
        {
          label: "ICMS",
          value: icms,
          totalValue: (
            (parseFloat(targetPrice) + parseFloat(portFreightPerUnitValue)) *
            icms *
            dollarPrice
          ).toFixed(2),
        },
        {
          label: "AFRMM",
          value: afrmmTax.value / 100,
          totalValue: (afrmmTax.type === "FIXED"
            ? (parseFloat(afrmmTax.value) /
                parseFloat(productQuantityInContainer)) *
              dollarPrice
            : parseFloat(targetPrice) * (afrmmTax.value / 100) * dollarPrice
          ).toFixed(2),
          type: afrmmTax.type,
        },
        {
          label: "Collect de frete",
          value: freightCollectTax.value / 100,
          totalValue: (freightCollectTax.type === "FIXED"
            ? (parseFloat(freightCollectTax.value) /
                parseFloat(productQuantityInContainer)) *
              dollarPrice
            : parseFloat(targetPrice) *
              (freightCollectTax.value / 100) *
              dollarPrice
          ).toFixed(2),
          type: freightCollectTax.type,
        },
        {
          label: "Outras despesas de frete",
          value: otherShippingTax.value / 100,
          type: otherShippingTax.type,
          totalValue: (otherShippingTax.type === "FIXED"
            ? (parseFloat(otherShippingTax.value) /
                parseFloat(productQuantityInContainer)) *
              dollarPrice
            : parseFloat(targetPrice) *
              (otherShippingTax.value / 100) *
              dollarPrice
          ).toFixed(2),
        },
        {
          label: "Desembaraço Aduaneiro",
          value: customsClearenceTax.value / 100,
          type: customsClearenceTax.type,
          totalValue: (customsClearenceTax.type === "FIXED"
            ? (parseFloat(customsClearenceTax.value) /
                parseFloat(productQuantityInContainer)) *
              dollarPrice
            : parseFloat(targetPrice) *
              (customsClearenceTax.value / 100) *
              dollarPrice
          ).toFixed(2),
        },
        {
          label: "Outras despesas",
          value: otherExpensesTax.value / 100,
          type: otherExpensesTax.type,
          totalValue: (otherExpensesTax.type === "FIXED"
            ? (parseFloat(otherExpensesTax.value) /
                parseFloat(productQuantityInContainer)) *
              dollarPrice
            : parseFloat(targetPrice) *
              (otherExpensesTax.value / 100) *
              dollarPrice
          ).toFixed(2),
        },
        {
          label: "Armazenagem",
          value: storageTax.value / 100,
          type: storageTax.type,
          totalValue: (storageTax.type === "FIXED"
            ? (parseFloat(storageTax.value) /
                parseFloat(productQuantityInContainer)) *
              dollarPrice
            : parseFloat(targetPrice) * (storageTax.value / 100) * dollarPrice
          ).toFixed(2),
        },
      ].map((item, index) => {
        totalTaxesCost += parseFloat(item.totalValue);

        return (
          <div key={index} className="flex items-center gap-4">
            <label className="w-40 text-gray-700 font-semibold">
              {item.label}
            </label>
            <div className="flex gap-2 w-full">
              <input
                className="w-full p-2 border text-center border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
                disabled
                value={
                  ((item.value || 0) * 100).toFixed(2) +
                  (item.type !== "FIXED" ? " %" : " $")
                }
              />
              <input
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
                disabled
                value={
                  "R$ " +
                  (typeof item.totalValue === "string" &&
                  item.totalValue !== "NaN"
                    ? item.totalValue
                    : 0)
                }
              />
            </div>
          </div>
        );
      })}
      <div className="flex items-center gap-4">
        <label className="w-40 text-gray-700 font-semibold">
          Frete Terrestre R$
        </label>
        <div className="flex gap-2 w-full">
          <input
            className="w-full p-2 border text-center border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
            value={landFreightPrice}
            onChange={(e) => setLandFreightPrice(e.target.value)}
          />
          <input
            className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
            step={0.01}
            disabled
            value={
              "R$ " +
              (typeof landFreightPerUnitValue === "string" &&
              landFreightPerUnitValue !== "NaN"
                ? landFreightPerUnitValue
                : 0)
            }
          />
        </div>
      </div>
      <div className="flex items-center gap-4 p-4 bg-gray-300 rounded-lg">
        <label className="w-40 text-gray-700 font-bold">Custo Total R$</label>
        <div className="flex gap-2 w-full">
          <input
            className="w-full p-2 border text-center border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
            value={
              "R$ " +
              (typeof chinaPriceToBrl === "string" && chinaPriceToBrl !== "NaN"
                ? chinaPriceToBrl
                : 0)
            }
            disabled
          />
          <input
            className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
            disabled
            value={
              "R$ " +
              (isNaN(
                totalTaxesCost +
                  parseFloat(landFreightPerUnitValue) +
                  portFreightPerUnitValue * dollarPrice
              )
                ? 0
                : (
                    totalTaxesCost +
                    parseFloat(landFreightPerUnitValue) +
                    portFreightPerUnitValue * dollarPrice
                  ).toFixed(2))
            }
          />

          <input
            className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
            disabled
            value={
              "R$ " +
              (isNaN(
                totalTaxesCost +
                  parseFloat(landFreightPerUnitValue) +
                  portFreightPerUnitValue * dollarPrice +
                  parseFloat(chinaPriceToBrl)
              )
                ? 0
                : totalTaxesCost +
                  parseFloat(landFreightPerUnitValue) +
                  portFreightPerUnitValue * dollarPrice +
                  parseFloat(chinaPriceToBrl)
              ).toFixed(2)
            }
          />
        </div>
      </div>
    </div>
  );
}
export default ImportCosts;
